import { PermissionState } from '../types/PermissionState'
import { GeolocationService } from './GeolocationService'

export class PermissionService {
    static async checkGeolocationPermission(): Promise<PermissionState> {
        if (!navigator.permissions) {
            return 'prompt'
        }

        try {
            const result = await navigator.permissions.query({
                name: 'geolocation' as PermissionName
            })

            return result.state as PermissionState
        } catch {
            return 'prompt'
        }
    }

    static async requestGeolocationPermission(): Promise<PermissionState> {
        try {
            await GeolocationService.getCurrentPosition({ timeout: 5000 })
            return 'granted'

        } catch (error) {
            const locationError = error as { code: number, message: string }
            return locationError.code === 1 ? 'denied' : 'prompt'
        }
    }

    static onPermissionChange(callback: (state: PermissionState) => void): () => void {
        if (!navigator.permissions) {
            return () => { }
        }

        let permissionStatus: PermissionStatus | null = null

        navigator.permissions.query({ name: 'geolocation' as PermissionName })
            .then((status) => {
                permissionStatus = status
                status.onchange = () => callback(status.state as PermissionState)
            })
            .catch(() => {})

        return () => {
            if (permissionStatus) {
                permissionStatus.onchange = null
            }
        }
    }
}